exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-datepicker-content-touch {\r\n  margin: 0;\r\n  padding: 30px;\r\n}\r\n\r\n.error {\r\n  font-size: 18px;\r\n  color: red;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar-add/calendar-add.component.css
// module id = ../../../../../src/app/calendar/calendar-add/calendar-add.component.css
// module chunks = main